import React from "react";

export default class LanguageTranslationItemTable extends React.Component {
    constructor(props) {
        super();

        this.scrollableRef = React.createRef();
    }

    componentDidMount() {
        this.props.updateScrollRef(this.scrollableRef.current);
    }

    componentWillUnmount() {
        this.props.updateScrollRef(null);
    }

    renderTable = () => {
        if (!this.props.selectedApp) {
            return null;
        }

        const tableRender = this.props.updatedLanguageItems
                .filter(langItem => !langItem.deleteMe)
                .map((langItem, index) => {
                    const langTransItem = this.props.updatedLanguageTranslationItems.find(
                (translationitem) => langItem.id === translationitem.languageItem && !translationitem.deleteMe
            );            

            return (
                <div
                    className="languageDisplay_grid"
                    key={index + this.props.selectedApp + this.props.selectedLanguage}
                >
                    <input
                        className="languageDisplay_styles left"
                        value={langItem.key}
                        readOnly
                        disabled
                    ></input>
                    <input
                        className="languageDisplay_styles"
                        type="text"
                        value={langTransItem && langTransItem.value ? langTransItem.value : ""}
                        onChange={(e) => {
                            if (langTransItem) {
                                this.props.setLangaugeTranslationItems(langTransItem.id, e.target.value, "value")
                            } else {
                                this.props.setLangaugeTranslationItems("new", e.target.value, "value", langItem.id)
                            }
                        }
                        }
                    ></input>
                    <input
                        className="languageDisplay_styles"
                        type="text"
                        value={!!langItem.lastUpdated && !langItem.lastUpdated.startsWith("0000") ? new Date(langItem.lastUpdated).toLocaleDateString("en-GB") : ""}
                        readOnly
                        disabled
                    ></input>
                </div>
            );
        });

        tableRender.push(
            <div className="languageDisplay_grid" key="additionalRow">
                <input
                    className="languageDisplay_styles left"
                    value=""
                    readOnly
                    disabled
                ></input>
                <input
                    className="languageDisplay_styles"
                    type="text"
                    value=""
                    readOnly
                    disabled
                ></input>
                <input
                    className="languageDisplay_styles"
                    type="text"
                    value=""
                    readOnly
                    disabled
                ></input>
            </div>
        );

        return tableRender;
    };

    render() {
        return (
            <div
                className="DropDown_Height"
                ref={this.scrollableRef}
                onScroll={this.props.tableOnScroll}
            >
                {this.renderTable()}
                {/* user can add english phrases and text here, add button to save details onto the languageItem table.  */}
            </div>
        );
    }
}
